import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import MarketingNav from '../components/MarketingNav';
import StatuteRouteSEO from '../components/StatuteRouteSEO';
import Library from './Library';
import { useAuth } from '../contexts/AuthContext';

export default function PublicStatutes() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    navigate('/library', { replace: true });
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-[#fafafa] text-zinc-900 overflow-x-hidden">
      <StatuteRouteSEO />
      <MarketingNav />
      <section className="pt-24 pb-8 px-4 md:px-6">
        <Library isPublic basePath="/statutes" />
      </section>
    </div>
  );
}
